import request from '../utils/request'

export default {
  async list (data) {
    const ret = await request('/v1/deviceBeacon/list', data,'POST')
    return ret
  },
  async save (data) { 
    const ret = await request('/v1/deviceBeacon/save', data,'POST')
    return ret
  },
  async delete (data) { 
    const ret = await request('/v1/deviceBeacon/delete', data,'POST')
    return ret
  }
}
